import { render } from "./InspectionSection.vue?vue&type=template&id=af980ac0&scoped=true"
import script from "./InspectionSection.vue?vue&type=script&lang=js"
export * from "./InspectionSection.vue?vue&type=script&lang=js"

import "./InspectionSection.vue?vue&type=style&index=0&id=af980ac0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af980ac0"]])

export default __exports__